import { useEffect, useState } from 'react';

const useIsDesktop = (): boolean => {
	const [isDesktop, setIsDesktop] = useState(true);

	useEffect(() => {
		const handleResize = (): void => {
			setTimeout(() => setIsDesktop(window.innerWidth >= 1024), 100);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return isDesktop;
};

export default useIsDesktop;
